export const transformLeasingValue = (value: string): string => {
    if (value === 'Yes') return 'YES';
    if (value === 'No') return 'NO';
    if (value === 'Undecided, need more information') return 'UNDECIDED';
    return 'UNDECIDED';
};

export const transformDmsValue = (value: string): string => {
    if (value === 'CDK Global') return 'CDK';
    return value;
};

export const transformPhoneForApi = (phone: string): string => {
    const digits = phone.replace(/\D/g, '');
    if (digits.length === 10) {
        return `1-${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6)}`;
    }
    return phone;
};
